// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Inter/static/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Inter/static/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Inter/static/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Inter/static/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Inter/static/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Merriweather_Sans/static/MerriweatherSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Merriweather_Sans/static/MerriweatherSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Merriweather_Sans/static/MerriweatherSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Merriweather_Sans/static/MerriweatherSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Merriweather_Sans/static/MerriweatherSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Kodchasan/Kodchasan-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Kodchasan/Kodchasan-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Kodchasan/Kodchasan-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Kodchasan/Kodchasan-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Kodchasan/Kodchasan-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Be_Vietnam/BeVietnam-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Be_Vietnam/BeVietnam-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Be_Vietnam/BeVietnam-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Be_Vietnam/BeVietnam-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Be_Vietnam/BeVietnam-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --c-primary-50: 238, 242, 255;
  --c-primary-100: 224, 231, 255;
  --c-primary-200: 199, 210, 254;
  --c-primary-300: 165, 180, 252;
  --c-primary-400: 129, 140, 248;
  --c-primary-500: 99, 102, 241;
  --c-primary-600: 79, 70, 229;
  --c-primary-700: 67, 56, 202;
  --c-primary-800: 55, 48, 163;
  --c-primary-900: 49, 46, 129;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 249, 250, 251;
  --c-neutral-100: 243, 244, 246;
  --c-neutral-200: 229, 231, 235;
  --c-neutral-300: 209, 213, 219;
  --c-neutral-400: 156, 163, 175;
  --c-neutral-500: 107, 114, 128;
  --c-neutral-600: 75, 85, 99;
  --c-neutral-700: 55, 65, 81;
  --c-neutral-800: 31, 41, 55;
  --c-neutral-900: 17, 24, 39;
}

.theme-cyan-blueGrey {
  --c-primary-50: 236, 254, 255;
  --c-primary-100: 207, 250, 254;
  --c-primary-200: 165, 243, 252;
  --c-primary-300: 103, 232, 249;
  --c-primary-400: 34, 211, 238;
  --c-primary-500: 6, 182, 212;
  --c-primary-600: 8, 145, 178;
  --c-primary-700: 14, 116, 144;
  --c-primary-800: 21, 94, 117;
  --c-primary-900: 22, 78, 99;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

.theme-blue-blueGrey {
  --c-primary-50: 239, 246, 255;
  --c-primary-100: 219, 234, 254;
  --c-primary-200: 191, 219, 254;
  --c-primary-300: 147, 197, 253;
  --c-primary-400: 96, 165, 250;
  --c-primary-500: 59, 130, 246;
  --c-primary-600: 37, 99, 235;
  --c-primary-700: 29, 78, 216;
  --c-primary-800: 30, 64, 175;
  --c-primary-900: 30, 58, 138;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

.theme-purple-blueGrey {
  --c-primary-50: 250, 245, 255;
  --c-primary-100: 243, 232, 255;
  --c-primary-200: 233, 213, 255;
  --c-primary-300: 216, 180, 254;
  --c-primary-400: 192, 132, 252;
  --c-primary-500: 168, 85, 247;
  --c-primary-600: 147, 51, 234;
  --c-primary-700: 126, 34, 206;
  --c-primary-800: 107, 33, 168;
  --c-primary-900: 88, 28, 135;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

.theme-teal-blueGrey {
  --c-primary-50: 240, 253, 250;
  --c-primary-100: 204, 251, 241;
  --c-primary-200: 153, 246, 228;
  --c-primary-300: 94, 234, 212;
  --c-primary-400: 45, 212, 191;
  --c-primary-500: 20, 184, 166;
  --c-primary-600: 13, 148, 136;
  --c-primary-700: 15, 118, 110;
  --c-primary-800: 17, 94, 89;
  --c-primary-900: 19, 78, 74;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

.theme-blueGrey-blueGrey {
  --c-primary-50: 248, 250, 252;
  --c-primary-100: 241, 245, 249;
  --c-primary-200: 226, 232, 240;
  --c-primary-300: 203, 213, 225;
  --c-primary-400: 148, 163, 184;
  --c-primary-500: 100, 116, 139;
  --c-primary-600: 71, 85, 105;
  --c-primary-700: 51, 65, 85;
  --c-primary-800: 30, 41, 59;
  --c-primary-900: 15, 23, 42;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

.theme-red-warmGrey {
  --c-primary-50: 254, 242, 242;
  --c-primary-100: 254, 226, 226;
  --c-primary-200: 254, 226, 226;
  --c-primary-300: 254, 226, 226;
  --c-primary-400: 248, 113, 113;
  --c-primary-500: 239, 68, 68;
  --c-primary-600: 220, 38, 38;
  --c-primary-700: 185, 28, 28;
  --c-primary-800: 153, 27, 27;
  --c-primary-900: 127, 29, 29;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 250, 250, 249;
  --c-neutral-100: 245, 245, 244;
  --c-neutral-200: 231, 229, 228;
  --c-neutral-300: 214, 211, 209;
  --c-neutral-400: 168, 162, 158;
  --c-neutral-500: 120, 113, 108;
  --c-neutral-600: 87, 83, 78;
  --c-neutral-700: 68, 64, 60;
  --c-neutral-800: 41, 37, 36;
  --c-neutral-900: 28, 25, 23;
}

.theme-cyan-warmGrey {
  --c-primary-50: 236, 254, 255;
  --c-primary-100: 207, 250, 254;
  --c-primary-200: 165, 243, 252;
  --c-primary-300: 103, 232, 249;
  --c-primary-400: 34, 211, 238;
  --c-primary-500: 6, 182, 212;
  --c-primary-600: 8, 145, 178;
  --c-primary-700: 14, 116, 144;
  --c-primary-800: 21, 94, 117;
  --c-primary-900: 22, 78, 99;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 250, 250, 249;
  --c-neutral-100: 245, 245, 244;
  --c-neutral-200: 231, 229, 228;
  --c-neutral-300: 214, 211, 209;
  --c-neutral-400: 168, 162, 158;
  --c-neutral-500: 120, 113, 108;
  --c-neutral-600: 87, 83, 78;
  --c-neutral-700: 68, 64, 60;
  --c-neutral-800: 41, 37, 36;
  --c-neutral-900: 28, 25, 23;
}

.theme-blue-coolGrey {
  --c-primary-50: 239, 246, 255;
  --c-primary-100: 219, 234, 254;
  --c-primary-200: 191, 219, 254;
  --c-primary-300: 147, 197, 253;
  --c-primary-400: 96, 165, 250;
  --c-primary-500: 59, 130, 246;
  --c-primary-600: 37, 99, 235;
  --c-primary-700: 29, 78, 216;
  --c-primary-800: 30, 64, 175;
  --c-primary-900: 30, 58, 138;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 249, 250, 251;
  --c-neutral-100: 243, 244, 246;
  --c-neutral-200: 229, 231, 235;
  --c-neutral-300: 209, 213, 219;
  --c-neutral-400: 156, 163, 175;
  --c-neutral-500: 107, 114, 128;
  --c-neutral-600: 75, 85, 99;
  --c-neutral-700: 55, 65, 81;
  --c-neutral-800: 31, 41, 55;
  --c-neutral-900: 17, 24, 39;
}

.theme-lightBlue-coolGrey {
  --c-primary-50: 240, 249, 255;
  --c-primary-100: 224, 242, 254;
  --c-primary-200: 186, 230, 253;
  --c-primary-300: 125, 211, 252;
  --c-primary-400: 56, 189, 248;
  --c-primary-500: 14, 165, 233;
  --c-primary-600: 2, 132, 199;
  --c-primary-700: 3, 105, 161;
  --c-primary-800: 7, 89, 133;
  --c-primary-900: 12, 74, 110;
  --c-secondary-50: 240, 253, 244;
  --c-secondary-100: 220, 252, 231;
  --c-secondary-200: 187, 247, 208;
  --c-secondary-300: 134, 239, 172;
  --c-secondary-400: 74, 222, 128;
  --c-secondary-500: 34, 197, 94;
  --c-secondary-600: 22, 163, 74;
  --c-secondary-700: 21, 128, 61;
  --c-secondary-800: 22, 101, 52;
  --c-secondary-900: 20, 83, 45;
  --c-neutral-50: 249, 250, 251;
  --c-neutral-100: 243, 244, 246;
  --c-neutral-200: 229, 231, 235;
  --c-neutral-300: 209, 213, 219;
  --c-neutral-400: 156, 163, 175;
  --c-neutral-500: 107, 114, 128;
  --c-neutral-600: 75, 85, 99;
  --c-neutral-700: 55, 65, 81;
  --c-neutral-800: 31, 41, 55;
  --c-neutral-900: 17, 24, 39;
}

.theme-pink-coolGrey {
  --c-primary-50: 253, 242, 248;
  --c-primary-100: 252, 231, 243;
  --c-primary-200: 252, 231, 243;
  --c-primary-300: 249, 168, 212;
  --c-primary-400: 244, 114, 182;
  --c-primary-500: 236, 72, 153;
  --c-primary-600: 219, 39, 119;
  --c-primary-700: 190, 24, 93;
  --c-primary-800: 157, 23, 77;
  --c-primary-900: 131, 24, 67;
}

.theme-green-grey {
  --c-primary-50: 240, 253, 244;
  --c-primary-100: 220, 252, 231;
  --c-primary-200: 187, 247, 208;
  --c-primary-300: 134, 239, 172;
  --c-primary-400: 74, 222, 128;
  --c-primary-500: 34, 197, 94;
  --c-primary-600: 22, 163, 74;
  --c-primary-700: 21, 128, 61;
  --c-primary-800: 22, 101, 52;
  --c-primary-900: 20, 83, 45;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 250, 250, 250;
  --c-neutral-100: 244, 244, 245;
  --c-neutral-200: 228, 228, 231;
  --c-neutral-300: 212, 212, 216;
  --c-neutral-400: 161, 161, 170;
  --c-neutral-500: 113, 113, 122;
  --c-neutral-600: 82, 82, 91;
  --c-neutral-700: 63, 63, 70;
  --c-neutral-800: 39, 39, 42;
  --c-neutral-900: 24, 24, 27;
}

.theme-yellow-grey {
  --c-primary-50: 254, 252, 232;
  --c-primary-100: 254, 249, 195;
  --c-primary-200: 254, 240, 138;
  --c-primary-300: 253, 224, 71;
  --c-primary-400: 250, 204, 21;
  --c-primary-500: 234, 179, 8;
  --c-primary-600: 202, 138, 4;
  --c-primary-700: 161, 98, 7;
  --c-primary-800: 133, 77, 14;
  --c-primary-900: 133, 77, 14;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 250, 250, 250;
  --c-neutral-100: 244, 244, 245;
  --c-neutral-200: 228, 228, 231;
  --c-neutral-300: 212, 212, 216;
  --c-neutral-400: 161, 161, 170;
  --c-neutral-500: 113, 113, 122;
  --c-neutral-600: 82, 82, 91;
  --c-neutral-700: 63, 63, 70;
  --c-neutral-800: 39, 39, 42;
  --c-neutral-900: 24, 24, 27;
}

.theme-orange-grey {
  --c-primary-50: 255, 247, 237;
  --c-primary-100: 255, 237, 213;
  --c-primary-200: 254, 215, 170;
  --c-primary-300: 253, 186, 116;
  --c-primary-400: 251, 146, 60;
  --c-primary-500: 249, 115, 22;
  --c-primary-600: 234, 88, 12;
  --c-primary-700: 194, 65, 12;
  --c-primary-800: 154, 52, 18;
  --c-primary-900: 124, 45, 18;
  --c-secondary-50: 247, 254, 231;
  --c-secondary-100: 236, 252, 203;
  --c-secondary-200: 217, 249, 157;
  --c-secondary-300: 190, 242, 100;
  --c-secondary-400: 163, 230, 53;
  --c-secondary-500: 132, 204, 22;
  --c-secondary-600: 101, 163, 13;
  --c-secondary-700: 77, 124, 15;
  --c-secondary-800: 63, 98, 18;
  --c-secondary-900: 54, 83, 20;
  --c-neutral-50: 250, 250, 250;
  --c-neutral-100: 244, 244, 245;
  --c-neutral-200: 228, 228, 231;
  --c-neutral-300: 212, 212, 216;
  --c-neutral-400: 161, 161, 170;
  --c-neutral-500: 113, 113, 122;
  --c-neutral-600: 82, 82, 91;
  --c-neutral-700: 63, 63, 70;
  --c-neutral-800: 39, 39, 42;
  --c-neutral-900: 24, 24, 27;
}

.theme-fuchsia-blueGrey {
  --c-primary-50: 253, 244, 255;
  --c-primary-100: 250, 232, 255;
  --c-primary-200: 245, 208, 254;
  --c-primary-300: 240, 171, 252;
  --c-primary-400: 232, 121, 249;
  --c-primary-500: 217, 70, 239;
  --c-primary-600: 192, 38, 211;
  --c-primary-700: 162, 28, 175;
  --c-primary-800: 134, 25, 143;
  --c-primary-900: 112, 26, 117;
  --c-secondary-50: 240, 253, 250;
  --c-secondary-100: 204, 251, 241;
  --c-secondary-200: 153, 246, 228;
  --c-secondary-300: 153, 246, 228;
  --c-secondary-400: 45, 212, 191;
  --c-secondary-500: 20, 184, 166;
  --c-secondary-600: 13, 148, 136;
  --c-secondary-700: 15, 118, 110;
  --c-secondary-800: 17, 94, 89;
  --c-secondary-900: 19, 78, 74;
  --c-neutral-50: 248, 250, 252;
  --c-neutral-100: 241, 245, 249;
  --c-neutral-200: 226, 232, 240;
  --c-neutral-300: 203, 213, 225;
  --c-neutral-400: 148, 163, 184;
  --c-neutral-500: 100, 116, 139;
  --c-neutral-600: 71, 85, 105;
  --c-neutral-700: 51, 65, 85;
  --c-neutral-800: 30, 41, 59;
  --c-neutral-900: 15, 23, 42;
}

@font-face {
  font-family: Inter;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: Inter;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: Inter;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: Inter;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: Inter;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: Poppins;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: Poppins;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: Poppins;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: Poppins;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
@font-face {
  font-family: Poppins;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
@font-face {
  font-family: MerriweatherSans;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
@font-face {
  font-family: MerriweatherSans;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
@font-face {
  font-family: MerriweatherSans;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
@font-face {
  font-family: MerriweatherSans;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
@font-face {
  font-family: MerriweatherSans;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
@font-face {
  font-family: Kodchasan;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
@font-face {
  font-family: Kodchasan;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
@font-face {
  font-family: Kodchasan;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
@font-face {
  font-family: Kodchasan;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
@font-face {
  font-family: Kodchasan;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
@font-face {
  font-family: BeVietnam;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
@font-face {
  font-family: BeVietnam;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
@font-face {
  font-family: BeVietnam;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
@font-face {
  font-family: BeVietnam;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
@font-face {
  font-family: BeVietnam;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
html body {
  font-family: var(--font-body), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-display), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

:root {
  --font-display: Poppins;
  --font-body: Poppins;
}

.theme-animals {
  --font-display: Inter;
  --font-body: Inter;
}

.theme-astronomy {
  --font-display: BeVietnam;
  --font-body: BeVietnam;
}

.root {
  overflow: hidden;
}

#headlessui-portal-root {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(var(--c-neutral-900), var(--tw-text-opacity));
}

#headlessui-portal-root:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgba(var(--c-neutral-200), var(--tw-text-opacity));
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hiddenScrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hiddenScrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.z-max {
  z-index: 999999999;
}

.nc-will-change-transform {
  will-change: transform;
}

.nc-will-change-top {
  will-change: top;
}

.nc-SectionClientSay .glide__bullet--active {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-neutral-700), var(--tw-bg-opacity));
}

.nc-GallerySlider .glide__bullet--active {
  height: 0.5rem;
  width: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.nc-card-title {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
}

.nc-card-title:hover {
  --tw-text-opacity: 1;
  color: rgba(var(--c-primary-900), var(--tw-text-opacity));
}

.nc-card-title:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgba(var(--c-primary-300), var(--tw-text-opacity));
}

.nc-PostCardCommentBtn:hover span,
.nc-PostCardLikeAction:hover span,
.nc-CommentCardLikeReply > button:hover span {
  color: inherit;
}

.nc-box-has-hover {
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgba(var(--c-neutral-200), var(--tw-border-opacity));
  --tw-border-opacity: 0.7;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.nc-box-has-hover:hover {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-neutral-50), var(--tw-bg-opacity));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.nc-dark-box-bg-has-hover:is(.dark *) {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-700), var(--tw-border-opacity));
  background-color: rgba(var(--c-neutral-800), var(--tw-bg-opacity));
  --tw-bg-opacity: 0.3;
}

.nc-dark-box-bg-has-hover:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-neutral-800), var(--tw-bg-opacity));
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.nc-dark-box-bg:is(.dark *) {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-700), var(--tw-border-opacity));
  background-color: rgba(var(--c-neutral-800), var(--tw-bg-opacity));
  --tw-bg-opacity: 0.3;
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.nc-origin-100 {
  transform-origin: 100% 50% 0px;
}

.nc-origin-50 {
  transform-origin: 50% 50% 0px;
}

.nc-hero-field-padding {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .nc-hero-field-padding {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .nc-hero-field-padding {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.nc-hero-field-padding--small {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .nc-hero-field-padding--small {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .nc-hero-field-padding--small {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.nc-hero-field-focused {
  border-radius: 9999px;
}

.nc-hero-field-focused:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}

.nc-hero-field-focused {
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}

.ListingDetailPage .nc-hero-field-focused {
  border-radius: 1.5rem;
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ListingDetailPage.nc-ListingExperiencesDetailPage .ExperiencesDateSingleInput .nc-hero-field-focused {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.ListingDetailPage.nc-ListingExperiencesDetailPage .listingExperiencesDetailPage__GuestsInput .nc-hero-field-focused {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.ListingDetailPage .DateRangePickerInput_clearDates,
.ListingDetailPage .SingleDatePickerInput_clearDate {
  border-radius: 9999px;
  background-color: rgba(var(--c-neutral-200), 0.9);
}
.ListingDetailPage .DateRangePickerInput_clearDates:is(.dark *),
.ListingDetailPage .SingleDatePickerInput_clearDate:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}
.ListingDetailPage .DateRangePickerInput_clearDates svg,
.ListingDetailPage .SingleDatePickerInput_clearDate svg {
  width: 0.5rem;
  fill: rgb(var(--c-neutral-700));
}
.ListingDetailPage .DateRangePickerInput_clearDates svg:is(.dark *),
.ListingDetailPage .SingleDatePickerInput_clearDate svg:is(.dark *) {
  fill: rgb(var(--c-neutral-300));
}

.nc-ListingStayDetailPage__guestsInput .nc-hero-field-focused {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.nc-ListingStayDetailPage__stayDatesRangeInput .nc-hero-field-focused {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.nc-hero-field-focused--2 {
  border-radius: 9999px;
}

.nc-hero-field-focused--2:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}

.nc-hero-field-focused--2 {
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}

.nc-flex-1 {
  flex: 1 0;
}

.nc-flex-1\\.5 {
  flex: 1.5 0;
}

.nc-flex-1\\.5-auto {
  flex: 1.5 0 auto;
}

.nc-flex-2 {
  flex: 2 0;
}

.nc-flex-2-auto {
  flex: 2 0 auto;
}

.nc-flex-2\\.5 {
  flex: 2.5 0;
}

@media (min-width: 1024px) {
  .lg\\:nc-flex-1\\.5 {
    flex: 1.5 0;
  }
  .lg\\:nc-flex-1\\.5-auto {
    flex: 1.5 0 auto;
  }
  .lg\\:nc-flex-2 {
    flex: 2 0;
  }
  .lg\\:nc-flex-2-auto {
    flex: 2 0 auto;
  }
  .lg\\:nc-flex-2\\.5 {
    flex: 2.5 0;
  }
}
.nc-icon-field {
  height: 1.25rem;
  width: 1.25rem;
}
@media (min-width: 1024px) {

  .nc-icon-field {
    height: 1.75rem;
    width: 1.75rem;
  }
}

.nc-icon-field-2 {
  height: 1.25rem;
  width: 1.25rem;
}

@media (min-width: 1024px) {

  .nc-icon-field-2 {
    height: 2rem;
    width: 2rem;
  }
}

button.gm-control-active.gm-fullscreen-control {
  border-radius: 0.75rem !important;
}

.nc-FiveStartIconForRate svg:hover ~ svg {
  --tw-text-opacity: 1;
  color: rgba(var(--c-neutral-300), var(--tw-text-opacity));
}

.listingSection__wrap {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.listingSection__wrap > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.listingSection__wrap {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-200), var(--tw-border-opacity));
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 2.5rem;
}

.listingSection__wrap:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-700), var(--tw-border-opacity));
}

@media (min-width: 640px) {

  .listingSection__wrap > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .listingSection__wrap {
    border-radius: 1rem;
    border-top-width: 1px;
    border-left-width: 1px;
    border-right-width: 1px;
    padding: 1rem;
  }
}

@media (min-width: 1280px) {

  .listingSection__wrap {
    padding: 2rem;
  }
}

.listingSectionSidebar__wrap {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.listingSectionSidebar__wrap > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.listingSectionSidebar__wrap {
  border-radius: 1rem;
  border-bottom-width: 1px;
  border-top-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-200), var(--tw-border-opacity));
  padding: 0.5rem;
  padding-bottom: 2.5rem;
}

.listingSectionSidebar__wrap:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-700), var(--tw-border-opacity));
}

@media (min-width: 640px) {

  .listingSectionSidebar__wrap {
    padding: 1rem;
  }
}

@media (min-width: 1280px) {

  .listingSectionSidebar__wrap > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
  }

  .listingSectionSidebar__wrap {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

input[type=time]::-webkit-calendar-picker-indicator {
  border-radius: 0.375rem;
}

input[type=time]:is(.dark *)::-webkit-calendar-picker-indicator {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-neutral-500), var(--tw-bg-opacity));
}

[type=button] {
  -webkit-appearance: none !important;
}

.rc-slider-track {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-primary-400), var(--tw-bg-opacity));
}

.rc-slider-handle {
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-primary-300), var(--tw-border-opacity));
}

.nc-PropertyCardH .nc-BtnLikeIcon--liked {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.nc-PropertyCardH .nc-BtnLikeIcon--liked:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.ncSectionLogos img {
  width: 100%;
  max-width: 200px;
}

.modalPhotos-single-gallery .glide__bullet--active {
  display: block;
}

.menuIsNew_lv1 > a::before {
  content: "New!";
  position: absolute;
  top: -2px;
  right: 0;
  display: inline-block;
  padding: 0 5px;
  line-height: 15px;
  border-radius: 4px;
  background-color: #f35656;
  color: #fff;
  font-size: 10px;
  font-weight: normal;
}

.menuIsNew > a::after {
  content: "New!";
  display: inline-block;
  padding: 0 5px;
  line-height: 15px;
  border-radius: 4px;
  background-color: #f35656;
  color: #fff;
  font-size: 10px;
  margin-left: 6px;
}

.FooterNav--hide {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes myblur {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.nc-custom-shadow-1 {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}

#desc ul {
  list-style-type: disc;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.ul-def {
  list-style-type: disc;
  padding-left: 1.25rem;
}

.headx {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0));
}

.icoLink {
  cursor: pointer;
}

iframe {
  display: none;
}

.videof {
  background: rgb(15, 23, 42);
  background: linear-gradient(90deg, rgb(15, 23, 42) 0%, rgba(9, 9, 121, 0.1755077031) 54%, rgb(15, 23, 42) 100%);
}

.react-datepicker {
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 2.5rem;
}

@media (min-width: 768px) {

  .react-datepicker {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.react-datepicker__aria-live {
  display: none;
}

.react-datepicker__month-container {
  text-align: center;
}

.react-datepicker__current-month {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.react-datepicker__current-month:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}

.react-datepicker__day-names {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  text-align: center;
  font-size: 0.75rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.react-datepicker__day-names:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.react-datepicker__month {
  margin-top: 1.25rem;
}

.react-datepicker__week {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.react-datepicker__day {
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.react-datepicker__day:empty {
  cursor: auto;
  opacity: 0;
}

.react-datepicker__day:hover:empty {
  background-color: transparent;
}

.react-datepicker__day:empty {
  background-color: transparent !important;
}
.react-datepicker__day span {
  border-radius: 9999px;
}
.react-datepicker__day span:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.react-datepicker__day span:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}
.react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range {
  border-radius: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.react-datepicker__day--in-range:is(.dark *), .react-datepicker__day--in-selecting-range:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.react-datepicker__day--selected span, .react-datepicker__day--range-start span, .react-datepicker__day--range-end span, .react-datepicker__day--selecting-range-start span, .react-datepicker__day--selecting-range-end span {
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-primary-500), var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.react-datepicker__day--selected span:hover, .react-datepicker__day--range-start span:hover, .react-datepicker__day--range-end span:hover, .react-datepicker__day--selecting-range-start span:hover, .react-datepicker__day--selecting-range-end span:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-primary-500), var(--tw-bg-opacity));
}
.react-datepicker__day--selected span:is(.dark *), .react-datepicker__day--range-start span:is(.dark *), .react-datepicker__day--range-end span:is(.dark *), .react-datepicker__day--selecting-range-start span:is(.dark *), .react-datepicker__day--selecting-range-end span:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-primary-500), var(--tw-bg-opacity));
}
.react-datepicker__day--selected span:hover:is(.dark *), .react-datepicker__day--range-start span:hover:is(.dark *), .react-datepicker__day--range-end span:hover:is(.dark *), .react-datepicker__day--selecting-range-start span:hover:is(.dark *), .react-datepicker__day--selecting-range-end span:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgba(var(--c-primary-500), var(--tw-bg-opacity));
}
.react-datepicker__day--disabled {
  --tw-text-opacity: 1;
  color: rgba(var(--c-neutral-400), var(--tw-text-opacity));
}
.react-datepicker__day--disabled:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgba(var(--c-neutral-500), var(--tw-text-opacity));
}

.react-datepicker__day_span {
  display: flex;
  height: 46px;
  width: 46px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}

/* addListingDatePickerExclude */
.addListingDatePickerExclude .react-datepicker__day--disabled {
  position: relative;
  border-radius: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.addListingDatePickerExclude .react-datepicker__day--disabled:empty {
  opacity: 0;
}
.addListingDatePickerExclude .react-datepicker__day--disabled:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.addListingDatePickerExclude .react-datepicker__day--disabled::after {
  content: "";
  position: absolute;
  display: block;
  height: 100%;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-left-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-300), var(--tw-border-opacity));
}
.addListingDatePickerExclude .react-datepicker__day--disabled:is(.dark *)::after {
  --tw-border-opacity: 1;
  border-color: rgba(var(--c-neutral-700), var(--tw-border-opacity));
}

.nc-header-bg {
  background-color: rgb(255 255 255 / 0.7);
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.nc-header-bg:is(.dark *) {
  background-color: rgba(var(--c-neutral-900), 0.6);
}

.glide {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.glide * {
  box-sizing: inherit;
}
.glide__track {
  overflow: hidden;
}
.glide__slides {
  position: relative;
  width: 100%;
  list-style: none;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  touch-action: pan-Y;
  overflow: hidden;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;
  will-change: transform;
}
.glide__slides--dragging {
  -webkit-user-select: none;
          user-select: none;
}
.glide__slide {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  white-space: normal;
  -webkit-user-select: none;
          user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}
.glide__slide a {
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.glide__arrows {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.glide__bullets {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.glide--rtl {
  direction: rtl;
}`, "",{"version":3,"sources":["webpack://./src/styles/__theme_colors.scss","webpack://./src/styles/index.scss","webpack://./src/styles/__theme_font.scss","webpack://./src/styles/__theme_custom.scss","webpack://./src/styles/__dates_picker.scss","webpack://./src/styles/_header.scss","webpack://./node_modules/@glidejs/glide/src/assets/sass/glide.core.scss"],"names":[],"mappings":"AAGA;EAEE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAGA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACPF;;ADWA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EAGA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACXF;;ADeA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACdF;;ADkBA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACjBF;;ADqBA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACpBF;;ADwBA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACvBF;;AD2BA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AC1BF;;AD8BA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AC7BF;;ADiCA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AChCF;;ADoCA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EAGA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACpCF;;ADwCA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;ACrCF;;ADyCA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACxCF;;AD4CA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AC3CF;;AD+CA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AC9CF;;ADkDA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,+BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;ACnDF;;ACxdA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AD2dF;ACzdA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AD2dF;ACzdA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AD2dF;ACzdA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AD2dF;ACzdA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AD2dF;ACvdA;EACE,oBAAA;EACA,gBAAA;EACA,4CAAA;ADydF;ACvdA;EACE,oBAAA;EACA,gBAAA;EACA,4CAAA;ADydF;ACvdA;EACE,oBAAA;EACA,gBAAA;EACA,4CAAA;ADydF;ACvdA;EACE,oBAAA;EACA,gBAAA;EACA,4CAAA;ADydF;ACvdA;EACE,oBAAA;EACA,gBAAA;EACA,4CAAA;ADydF;ACpdA;EACE,6BAAA;EACA,gBAAA;EACA,6CAAA;ADsdF;ACpdA;EACE,6BAAA;EACA,gBAAA;EACA,6CAAA;ADsdF;ACpdA;EACE,6BAAA;EACA,gBAAA;EACA,6CAAA;ADsdF;ACpdA;EACE,6BAAA;EACA,gBAAA;EACA,6CAAA;ADsdF;ACpdA;EACE,6BAAA;EACA,gBAAA;EACA,6CAAA;ADsdF;ACldA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADodF;ACldA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADodF;ACldA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADodF;ACldA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADodF;ACldA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADodF;AChdA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADkdF;AChdA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADkdF;AChdA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADkdF;AChdA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADkdF;AChdA;EACE,sBAAA;EACA,gBAAA;EACA,6CAAA;ADkdF;AC7cE;EAAA,iJAAA;EAAA,mCAAA;EAAA;AAAA;;AAOA;;;;EAAA;AAAA;;AAGF;EACE,uBAAA;EACA,oBAAA;ADgdF;;AC7cA;EACE,qBAAA;EACA,kBAAA;ADgdF;;AC7cA;EACE,yBAAA;EACA,sBAAA;ADgdF;;AEhnBA;EACE,gBAAA;AFmnBF;;AE/mBE;EAAA,eAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAGF,gDAAA;AACA;EACE,aAAA;AFmnBF;;AEhnBA,4CAAA;AACA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AFmnBF;;AEhnBA;EACE,kBAAA;AFmnBF;;AE/mBA;EACE,sBAAA;AFknBF;;AEhnBA;EACE,gBAAA;AFmnBF;;AE9mBE;EAAA,kBAAA;EAAA;AAAA;;AAGA;EAAA,cAAA;EAAA,aAAA;EAAA,kBAAA;EAAA;AAAA;;AAKA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAQE;;;EACE,cAAA;AF+mBN;;AExmBE;EAAA,qBAAA;EAAA,iBAAA;EAAA,kEAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,yBAAA;EAAA,kBAAA;EAAA,iEAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;;AAIA;EAAA,iBAAA;EAAA,sBAAA;EAAA,kEAAA;EAAA,kEAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA,kEAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;;AAIA;EAAA,iBAAA;EAAA,sBAAA;EAAA,kEAAA;EAAA,kEAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;;AAIF;EACE,8BAAA;AF2mBF;;AEzmBA;EACE,6BAAA;AF4mBF;;AEvmBE;EAAA,oBAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,iBAAA;IAAA,oBAAA;IAAA,qBAAA;IAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,mBAAA;IAAA,sBAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;;AAIA;EAAA,oBAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,oBAAA;IAAA,uBAAA;IAAA,qBAAA;IAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AADF;EAEE,oFAAA;AF2mBF;;AErmBI;EAAA,qBAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAIE;EAAA,4BAAA;EAAA;AAAA;AAGA;EAAA,2BAAA;EAAA;AAAA;AAMF;;EAAA,qBAAA;EAAA;AAAA;AAAA;;EAAA;AAAA;AAEE;;EAAA,aAAA;EAAA;AAAA;AAAA;;EAAA;AAAA;;AAOF;EAAA,2BAAA;EAAA;AAAA;;AAKA;EAAA,+BAAA;EAAA;AAAA;;AAKF;EAAA;AAAA;;AAAA;EAAA;AAAA;;AADF;EAEE,oFAAA;AFmmBF;;AE/lBA;EACE,SAAA;AFkmBF;;AE/lBA;EACE,WAAA;AFkmBF;;AEhmBA;EACE,gBAAA;AFmmBF;;AEhmBA;EACE,SAAA;AFmmBF;;AEhmBA;EACE,cAAA;AFmmBF;;AEhmBA;EACE,WAAA;AFmmBF;;AEhmBA;EACE;IACE,WAAA;EFmmBF;EEjmBA;IACE,gBAAA;EFmmBF;EEhmBA;IACE,SAAA;EFkmBF;EE/lBA;IACE,cAAA;EFimBF;EE9lBA;IACE,WAAA;EFgmBF;AACF;AE5lBE;EAAA,eAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;;AAGA;EAAA,eAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,YAAA;IAAA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAME;EAAA,oBAAA;EAAA;AAAA;;AAMF;EAAA,aAAA;EAAA,WAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,kEAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,uBAAA;IAAA,4DAAA;IAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,qBAAA;IAAA,sBAAA;IAAA,uBAAA;IAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA;EAAA;AAAA;;AAKA;EAAA,aAAA;EAAA,WAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA,wBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,sBAAA;EAAA,kEAAA;EAAA,eAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,uBAAA;IAAA,+DAAA;IAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;;AAKA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAGF;EACE,mCAAA;AF0lBF;;AErlBE;EAAA,kBAAA;EAAA;AAAA;;AAGA;EAAA,sBAAA;EAAA;AAAA;;AAME;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAOA;EAAA,WAAA;EACA;AADA;;AAQA;EAAA;AAAA;;AAKF;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AFglBJ;;AE5kBE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AF+kBJ;;AE1kBE;EAAA,sBAAA;EAAA;AAAA;;AAGF;EACE;IACE,UAAA;EF8kBF;EE5kBA;IACE,UAAA;EF8kBF;AACF;AE3kBA;EACE,mFAAA;AF6kBF;;AEzkBA;EAEE,qBAAA;EACA,qBAAA;EACA,sBAAA;AF2kBF;;AExkBA;EACE,qBAAA;EACA,qBAAA;AF2kBF;;AExkBA;EAEE,uKAAA;AF0kBF;;AEtkBA;EAEE,eAAA;AFwkBF;;AErkBA;EAEI,aAAA;AFukBJ;;AE/jBA;EAEE,2BAAA;EACA,+GAAA;AFikBF;;AGr4BE;EAAA,kBAAA;EAAA,aAAA;EAAA,gDAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA;EAAA;AAAA;;AAGA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAIA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,aAAA;EAAA,gDAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAIA;EAAA,oBAAA;EAAA,uBAAA;EAAA,aAAA;EAAA;AAAA;;AAIA;EAAA,aAAA;EAAA,WAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA,YAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AACA;EAAA;AAAA;AAGE;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAKA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAKA;EAAA,8BAAA;EAAA;AAAA;AAIA;EAAA,+BAAA;EAAA;AAAA;AASE;EAAA,qBAAA;EAAA,kBAAA;EAAA,kEAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAKF;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAKF;EAAA,aAAA;EAAA,YAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA;AAAA;;AAGF,gCAAA;AAIM;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AACA;EACE,WAAA;EACA,kBAAA;EAAA,cAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,+LAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,kEAAA;AH23BR;AG33BQ;EAAA,sBAAA;EAAA;AAAA;;AC1EN;EAAA,wCAAA;EAAA,8BAAA;EAAA,+QAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;ACCF;EAME,kBAAA;EACA,WAAA;EACA,sBAAA;ALs8BF;AKp8BE;EACE,mBAAA;ALs8BJ;AKn8BE;EACE,gBAAA;ALq8BJ;AKl8BE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;ALo8BJ;AKl8BI;EACE,yBAAA;UAAA,iBAAA;ALo8BN;AKh8BE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2BAAA;EACA,wCAAA;ALk8BJ;AKh8BI;EACE,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;ALk8BN;AK97BE;EACE,2BAAA;EACA,yBAAA;UAAA,iBAAA;ALg8BJ;AK77BE;EACE,2BAAA;EACA,yBAAA;UAAA,iBAAA;AL+7BJ;AK57BE;EACE,cAAA;AL87BJ","sourcesContent":["// Change your color you want --- please input rgb color (ex: 22,33,44)\r\n\r\n// THEME PALETTE 10 indigo-coolGrey ==========================================\r\n:root {\r\n  // PRIMARY COLOR\r\n  --c-primary-50: 238, 242, 255;\r\n  --c-primary-100: 224, 231, 255;\r\n  --c-primary-200: 199, 210, 254;\r\n  --c-primary-300: 165, 180, 252;\r\n  --c-primary-400: 129, 140, 248;\r\n  --c-primary-500: 99, 102, 241;\r\n  --c-primary-600: 79, 70, 229;\r\n  --c-primary-700: 67, 56, 202;\r\n  --c-primary-800: 55, 48, 163;\r\n  --c-primary-900: 49, 46, 129;\r\n\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 249, 250, 251;\r\n  --c-neutral-100: 243, 244, 246;\r\n  --c-neutral-200: 229, 231, 235;\r\n  --c-neutral-300: 209, 213, 219;\r\n  --c-neutral-400: 156, 163, 175;\r\n  --c-neutral-500: 107, 114, 128;\r\n  --c-neutral-600: 75, 85, 99;\r\n  --c-neutral-700: 55, 65, 81;\r\n  --c-neutral-800: 31, 41, 55;\r\n  --c-neutral-900: 17, 24, 39;\r\n}\r\n\r\n// THEME PALETTE 1 ==========================================\r\n.theme-cyan-blueGrey {\r\n  --c-primary-50: 236, 254, 255;\r\n  --c-primary-100: 207, 250, 254;\r\n  --c-primary-200: 165, 243, 252;\r\n  --c-primary-300: 103, 232, 249;\r\n  --c-primary-400: 34, 211, 238;\r\n  --c-primary-500: 6, 182, 212;\r\n  --c-primary-600: 8, 145, 178;\r\n  --c-primary-700: 14, 116, 144;\r\n  --c-primary-800: 21, 94, 117;\r\n  --c-primary-900: 22, 78, 99;\r\n\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n\r\n// THEME PALETTE 2 ==========================================\r\n.theme-blue-blueGrey {\r\n  --c-primary-50: 239, 246, 255;\r\n  --c-primary-100: 219, 234, 254;\r\n  --c-primary-200: 191, 219, 254;\r\n  --c-primary-300: 147, 197, 253;\r\n  --c-primary-400: 96, 165, 250;\r\n  --c-primary-500: 59, 130, 246;\r\n  --c-primary-600: 37, 99, 235;\r\n  --c-primary-700: 29, 78, 216;\r\n  --c-primary-800: 30, 64, 175;\r\n  --c-primary-900: 30, 58, 138;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n\r\n// THEME PALETTE 3 ==========================================\r\n.theme-purple-blueGrey {\r\n  --c-primary-50: 250, 245, 255;\r\n  --c-primary-100: 243, 232, 255;\r\n  --c-primary-200: 233, 213, 255;\r\n  --c-primary-300: 216, 180, 254;\r\n  --c-primary-400: 192, 132, 252;\r\n  --c-primary-500: 168, 85, 247;\r\n  --c-primary-600: 147, 51, 234;\r\n  --c-primary-700: 126, 34, 206;\r\n  --c-primary-800: 107, 33, 168;\r\n  --c-primary-900: 88, 28, 135;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n\r\n// THEME PALETTE 4 ==========================================\r\n.theme-teal-blueGrey {\r\n  --c-primary-50: 240, 253, 250;\r\n  --c-primary-100: 204, 251, 241;\r\n  --c-primary-200: 153, 246, 228;\r\n  --c-primary-300: 94, 234, 212;\r\n  --c-primary-400: 45, 212, 191;\r\n  --c-primary-500: 20, 184, 166;\r\n  --c-primary-600: 13, 148, 136;\r\n  --c-primary-700: 15, 118, 110;\r\n  --c-primary-800: 17, 94, 89;\r\n  --c-primary-900: 19, 78, 74;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n\r\n// THEME PALETTE 5 ==========================================\r\n.theme-blueGrey-blueGrey {\r\n  --c-primary-50: 248, 250, 252;\r\n  --c-primary-100: 241, 245, 249;\r\n  --c-primary-200: 226, 232, 240;\r\n  --c-primary-300: 203, 213, 225;\r\n  --c-primary-400: 148, 163, 184;\r\n  --c-primary-500: 100, 116, 139;\r\n  --c-primary-600: 71, 85, 105;\r\n  --c-primary-700: 51, 65, 85;\r\n  --c-primary-800: 30, 41, 59;\r\n  --c-primary-900: 15, 23, 42;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n\r\n// THEME PALETTE 6 ==========================================\r\n.theme-red-warmGrey {\r\n  --c-primary-50: 254, 242, 242;\r\n  --c-primary-100: 254, 226, 226;\r\n  --c-primary-200: 254, 226, 226;\r\n  --c-primary-300: 254, 226, 226;\r\n  --c-primary-400: 248, 113, 113;\r\n  --c-primary-500: 239, 68, 68;\r\n  --c-primary-600: 220, 38, 38;\r\n  --c-primary-700: 185, 28, 28;\r\n  --c-primary-800: 153, 27, 27;\r\n  --c-primary-900: 127, 29, 29;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 250, 250, 249;\r\n  --c-neutral-100: 245, 245, 244;\r\n  --c-neutral-200: 231, 229, 228;\r\n  --c-neutral-300: 214, 211, 209;\r\n  --c-neutral-400: 168, 162, 158;\r\n  --c-neutral-500: 120, 113, 108;\r\n  --c-neutral-600: 87, 83, 78;\r\n  --c-neutral-700: 68, 64, 60;\r\n  --c-neutral-800: 41, 37, 36;\r\n  --c-neutral-900: 28, 25, 23;\r\n}\r\n\r\n// THEME PALETTE 7 ==========================================\r\n.theme-cyan-warmGrey {\r\n  --c-primary-50: 236, 254, 255;\r\n  --c-primary-100: 207, 250, 254;\r\n  --c-primary-200: 165, 243, 252;\r\n  --c-primary-300: 103, 232, 249;\r\n  --c-primary-400: 34, 211, 238;\r\n  --c-primary-500: 6, 182, 212;\r\n  --c-primary-600: 8, 145, 178;\r\n  --c-primary-700: 14, 116, 144;\r\n  --c-primary-800: 21, 94, 117;\r\n  --c-primary-900: 22, 78, 99;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 250, 250, 249;\r\n  --c-neutral-100: 245, 245, 244;\r\n  --c-neutral-200: 231, 229, 228;\r\n  --c-neutral-300: 214, 211, 209;\r\n  --c-neutral-400: 168, 162, 158;\r\n  --c-neutral-500: 120, 113, 108;\r\n  --c-neutral-600: 87, 83, 78;\r\n  --c-neutral-700: 68, 64, 60;\r\n  --c-neutral-800: 41, 37, 36;\r\n  --c-neutral-900: 28, 25, 23;\r\n}\r\n\r\n// THEME PALETTE 8 ==========================================\r\n.theme-blue-coolGrey {\r\n  --c-primary-50: 239, 246, 255;\r\n  --c-primary-100: 219, 234, 254;\r\n  --c-primary-200: 191, 219, 254;\r\n  --c-primary-300: 147, 197, 253;\r\n  --c-primary-400: 96, 165, 250;\r\n  --c-primary-500: 59, 130, 246;\r\n  --c-primary-600: 37, 99, 235;\r\n  --c-primary-700: 29, 78, 216;\r\n  --c-primary-800: 30, 64, 175;\r\n  --c-primary-900: 30, 58, 138;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 249, 250, 251;\r\n  --c-neutral-100: 243, 244, 246;\r\n  --c-neutral-200: 229, 231, 235;\r\n  --c-neutral-300: 209, 213, 219;\r\n  --c-neutral-400: 156, 163, 175;\r\n  --c-neutral-500: 107, 114, 128;\r\n  --c-neutral-600: 75, 85, 99;\r\n  --c-neutral-700: 55, 65, 81;\r\n  --c-neutral-800: 31, 41, 55;\r\n  --c-neutral-900: 17, 24, 39;\r\n}\r\n\r\n// THEME PALETTE 9 ==========================================\r\n.theme-lightBlue-coolGrey {\r\n  --c-primary-50: 240, 249, 255;\r\n  --c-primary-100: 224, 242, 254;\r\n  --c-primary-200: 186, 230, 253;\r\n  --c-primary-300: 125, 211, 252;\r\n  --c-primary-400: 56, 189, 248;\r\n  --c-primary-500: 14, 165, 233;\r\n  --c-primary-600: 2, 132, 199;\r\n  --c-primary-700: 3, 105, 161;\r\n  --c-primary-800: 7, 89, 133;\r\n  --c-primary-900: 12, 74, 110;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 244;\r\n  --c-secondary-100: 220, 252, 231;\r\n  --c-secondary-200: 187, 247, 208;\r\n  --c-secondary-300: 134, 239, 172;\r\n  --c-secondary-400: 74, 222, 128;\r\n  --c-secondary-500: 34, 197, 94;\r\n  --c-secondary-600: 22, 163, 74;\r\n  --c-secondary-700: 21, 128, 61;\r\n  --c-secondary-800: 22, 101, 52;\r\n  --c-secondary-900: 20, 83, 45;\r\n\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 249, 250, 251;\r\n  --c-neutral-100: 243, 244, 246;\r\n  --c-neutral-200: 229, 231, 235;\r\n  --c-neutral-300: 209, 213, 219;\r\n  --c-neutral-400: 156, 163, 175;\r\n  --c-neutral-500: 107, 114, 128;\r\n  --c-neutral-600: 75, 85, 99;\r\n  --c-neutral-700: 55, 65, 81;\r\n  --c-neutral-800: 31, 41, 55;\r\n  --c-neutral-900: 17, 24, 39;\r\n}\r\n\r\n// THEME PALETTE 11 ==========================================\r\n.theme-pink-coolGrey {\r\n  --c-primary-50: 253, 242, 248;\r\n  --c-primary-100: 252, 231, 243;\r\n  --c-primary-200: 252, 231, 243;\r\n  --c-primary-300: 249, 168, 212;\r\n  --c-primary-400: 244, 114, 182;\r\n  --c-primary-500: 236, 72, 153;\r\n  --c-primary-600: 219, 39, 119;\r\n  --c-primary-700: 190, 24, 93;\r\n  --c-primary-800: 157, 23, 77;\r\n  --c-primary-900: 131, 24, 67;\r\n}\r\n\r\n// THEME PALETTE 12 ==========================================\r\n.theme-green-grey {\r\n  --c-primary-50: 240, 253, 244;\r\n  --c-primary-100: 220, 252, 231;\r\n  --c-primary-200: 187, 247, 208;\r\n  --c-primary-300: 134, 239, 172;\r\n  --c-primary-400: 74, 222, 128;\r\n  --c-primary-500: 34, 197, 94;\r\n  --c-primary-600: 22, 163, 74;\r\n  --c-primary-700: 21, 128, 61;\r\n  --c-primary-800: 22, 101, 52;\r\n  --c-primary-900: 20, 83, 45;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 250, 250, 250;\r\n  --c-neutral-100: 244, 244, 245;\r\n  --c-neutral-200: 228, 228, 231;\r\n  --c-neutral-300: 212, 212, 216;\r\n  --c-neutral-400: 161, 161, 170;\r\n  --c-neutral-500: 113, 113, 122;\r\n  --c-neutral-600: 82, 82, 91;\r\n  --c-neutral-700: 63, 63, 70;\r\n  --c-neutral-800: 39, 39, 42;\r\n  --c-neutral-900: 24, 24, 27;\r\n}\r\n\r\n// THEME PALETTE 13 ==========================================\r\n.theme-yellow-grey {\r\n  --c-primary-50: 254, 252, 232;\r\n  --c-primary-100: 254, 249, 195;\r\n  --c-primary-200: 254, 240, 138;\r\n  --c-primary-300: 253, 224, 71;\r\n  --c-primary-400: 250, 204, 21;\r\n  --c-primary-500: 234, 179, 8;\r\n  --c-primary-600: 202, 138, 4;\r\n  --c-primary-700: 161, 98, 7;\r\n  --c-primary-800: 133, 77, 14;\r\n  --c-primary-900: 133, 77, 14;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 250, 250, 250;\r\n  --c-neutral-100: 244, 244, 245;\r\n  --c-neutral-200: 228, 228, 231;\r\n  --c-neutral-300: 212, 212, 216;\r\n  --c-neutral-400: 161, 161, 170;\r\n  --c-neutral-500: 113, 113, 122;\r\n  --c-neutral-600: 82, 82, 91;\r\n  --c-neutral-700: 63, 63, 70;\r\n  --c-neutral-800: 39, 39, 42;\r\n  --c-neutral-900: 24, 24, 27;\r\n}\r\n\r\n// THEME PALETTE 14 ==========================================\r\n.theme-orange-grey {\r\n  --c-primary-50: 255, 247, 237;\r\n  --c-primary-100: 255, 237, 213;\r\n  --c-primary-200: 254, 215, 170;\r\n  --c-primary-300: 253, 186, 116;\r\n  --c-primary-400: 251, 146, 60;\r\n  --c-primary-500: 249, 115, 22;\r\n  --c-primary-600: 234, 88, 12;\r\n  --c-primary-700: 194, 65, 12;\r\n  --c-primary-800: 154, 52, 18;\r\n  --c-primary-900: 124, 45, 18;\r\n  // SECONDARY COLOR\r\n  --c-secondary-50: 247, 254, 231;\r\n  --c-secondary-100: 236, 252, 203;\r\n  --c-secondary-200: 217, 249, 157;\r\n  --c-secondary-300: 190, 242, 100;\r\n  --c-secondary-400: 163, 230, 53;\r\n  --c-secondary-500: 132, 204, 22;\r\n  --c-secondary-600: 101, 163, 13;\r\n  --c-secondary-700: 77, 124, 15;\r\n  --c-secondary-800: 63, 98, 18;\r\n  --c-secondary-900: 54, 83, 20;\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 250, 250, 250;\r\n  --c-neutral-100: 244, 244, 245;\r\n  --c-neutral-200: 228, 228, 231;\r\n  --c-neutral-300: 212, 212, 216;\r\n  --c-neutral-400: 161, 161, 170;\r\n  --c-neutral-500: 113, 113, 122;\r\n  --c-neutral-600: 82, 82, 91;\r\n  --c-neutral-700: 63, 63, 70;\r\n  --c-neutral-800: 39, 39, 42;\r\n  --c-neutral-900: 24, 24, 27;\r\n}\r\n\r\n// THEME PALETTE 17 ==========================================\r\n.theme-fuchsia-blueGrey {\r\n  --c-primary-50: 253, 244, 255;\r\n  --c-primary-100: 250, 232, 255;\r\n  --c-primary-200: 245, 208, 254;\r\n  --c-primary-300: 240, 171, 252;\r\n  --c-primary-400: 232, 121, 249;\r\n  --c-primary-500: 217, 70, 239;\r\n  --c-primary-600: 192, 38, 211;\r\n  --c-primary-700: 162, 28, 175;\r\n  --c-primary-800: 134, 25, 143;\r\n  --c-primary-900: 112, 26, 117;\r\n  // SECONDARY COLOR\r\n\r\n  --c-secondary-50: 240, 253, 250;\r\n  --c-secondary-100: 204, 251, 241;\r\n  --c-secondary-200: 153, 246, 228;\r\n  --c-secondary-300: 153, 246, 228;\r\n  --c-secondary-400: 45, 212, 191;\r\n  --c-secondary-500: 20, 184, 166;\r\n  --c-secondary-600: 13, 148, 136;\r\n  --c-secondary-700: 15, 118, 110;\r\n  --c-secondary-800: 17, 94, 89;\r\n  --c-secondary-900: 19, 78, 74;\r\n\r\n  // NEUTRAL COLOR\r\n  --c-neutral-50: 248, 250, 252;\r\n  --c-neutral-100: 241, 245, 249;\r\n  --c-neutral-200: 226, 232, 240;\r\n  --c-neutral-300: 203, 213, 225;\r\n  --c-neutral-400: 148, 163, 184;\r\n  --c-neutral-500: 100, 116, 139;\r\n  --c-neutral-600: 71, 85, 105;\r\n  --c-neutral-700: 51, 65, 85;\r\n  --c-neutral-800: 30, 41, 59;\r\n  --c-neutral-900: 15, 23, 42;\r\n}\r\n",":root {\n  --c-primary-50: 238, 242, 255;\n  --c-primary-100: 224, 231, 255;\n  --c-primary-200: 199, 210, 254;\n  --c-primary-300: 165, 180, 252;\n  --c-primary-400: 129, 140, 248;\n  --c-primary-500: 99, 102, 241;\n  --c-primary-600: 79, 70, 229;\n  --c-primary-700: 67, 56, 202;\n  --c-primary-800: 55, 48, 163;\n  --c-primary-900: 49, 46, 129;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 249, 250, 251;\n  --c-neutral-100: 243, 244, 246;\n  --c-neutral-200: 229, 231, 235;\n  --c-neutral-300: 209, 213, 219;\n  --c-neutral-400: 156, 163, 175;\n  --c-neutral-500: 107, 114, 128;\n  --c-neutral-600: 75, 85, 99;\n  --c-neutral-700: 55, 65, 81;\n  --c-neutral-800: 31, 41, 55;\n  --c-neutral-900: 17, 24, 39;\n}\n\n.theme-cyan-blueGrey {\n  --c-primary-50: 236, 254, 255;\n  --c-primary-100: 207, 250, 254;\n  --c-primary-200: 165, 243, 252;\n  --c-primary-300: 103, 232, 249;\n  --c-primary-400: 34, 211, 238;\n  --c-primary-500: 6, 182, 212;\n  --c-primary-600: 8, 145, 178;\n  --c-primary-700: 14, 116, 144;\n  --c-primary-800: 21, 94, 117;\n  --c-primary-900: 22, 78, 99;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n.theme-blue-blueGrey {\n  --c-primary-50: 239, 246, 255;\n  --c-primary-100: 219, 234, 254;\n  --c-primary-200: 191, 219, 254;\n  --c-primary-300: 147, 197, 253;\n  --c-primary-400: 96, 165, 250;\n  --c-primary-500: 59, 130, 246;\n  --c-primary-600: 37, 99, 235;\n  --c-primary-700: 29, 78, 216;\n  --c-primary-800: 30, 64, 175;\n  --c-primary-900: 30, 58, 138;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n.theme-purple-blueGrey {\n  --c-primary-50: 250, 245, 255;\n  --c-primary-100: 243, 232, 255;\n  --c-primary-200: 233, 213, 255;\n  --c-primary-300: 216, 180, 254;\n  --c-primary-400: 192, 132, 252;\n  --c-primary-500: 168, 85, 247;\n  --c-primary-600: 147, 51, 234;\n  --c-primary-700: 126, 34, 206;\n  --c-primary-800: 107, 33, 168;\n  --c-primary-900: 88, 28, 135;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n.theme-teal-blueGrey {\n  --c-primary-50: 240, 253, 250;\n  --c-primary-100: 204, 251, 241;\n  --c-primary-200: 153, 246, 228;\n  --c-primary-300: 94, 234, 212;\n  --c-primary-400: 45, 212, 191;\n  --c-primary-500: 20, 184, 166;\n  --c-primary-600: 13, 148, 136;\n  --c-primary-700: 15, 118, 110;\n  --c-primary-800: 17, 94, 89;\n  --c-primary-900: 19, 78, 74;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n.theme-blueGrey-blueGrey {\n  --c-primary-50: 248, 250, 252;\n  --c-primary-100: 241, 245, 249;\n  --c-primary-200: 226, 232, 240;\n  --c-primary-300: 203, 213, 225;\n  --c-primary-400: 148, 163, 184;\n  --c-primary-500: 100, 116, 139;\n  --c-primary-600: 71, 85, 105;\n  --c-primary-700: 51, 65, 85;\n  --c-primary-800: 30, 41, 59;\n  --c-primary-900: 15, 23, 42;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n.theme-red-warmGrey {\n  --c-primary-50: 254, 242, 242;\n  --c-primary-100: 254, 226, 226;\n  --c-primary-200: 254, 226, 226;\n  --c-primary-300: 254, 226, 226;\n  --c-primary-400: 248, 113, 113;\n  --c-primary-500: 239, 68, 68;\n  --c-primary-600: 220, 38, 38;\n  --c-primary-700: 185, 28, 28;\n  --c-primary-800: 153, 27, 27;\n  --c-primary-900: 127, 29, 29;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 250, 250, 249;\n  --c-neutral-100: 245, 245, 244;\n  --c-neutral-200: 231, 229, 228;\n  --c-neutral-300: 214, 211, 209;\n  --c-neutral-400: 168, 162, 158;\n  --c-neutral-500: 120, 113, 108;\n  --c-neutral-600: 87, 83, 78;\n  --c-neutral-700: 68, 64, 60;\n  --c-neutral-800: 41, 37, 36;\n  --c-neutral-900: 28, 25, 23;\n}\n\n.theme-cyan-warmGrey {\n  --c-primary-50: 236, 254, 255;\n  --c-primary-100: 207, 250, 254;\n  --c-primary-200: 165, 243, 252;\n  --c-primary-300: 103, 232, 249;\n  --c-primary-400: 34, 211, 238;\n  --c-primary-500: 6, 182, 212;\n  --c-primary-600: 8, 145, 178;\n  --c-primary-700: 14, 116, 144;\n  --c-primary-800: 21, 94, 117;\n  --c-primary-900: 22, 78, 99;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 250, 250, 249;\n  --c-neutral-100: 245, 245, 244;\n  --c-neutral-200: 231, 229, 228;\n  --c-neutral-300: 214, 211, 209;\n  --c-neutral-400: 168, 162, 158;\n  --c-neutral-500: 120, 113, 108;\n  --c-neutral-600: 87, 83, 78;\n  --c-neutral-700: 68, 64, 60;\n  --c-neutral-800: 41, 37, 36;\n  --c-neutral-900: 28, 25, 23;\n}\n\n.theme-blue-coolGrey {\n  --c-primary-50: 239, 246, 255;\n  --c-primary-100: 219, 234, 254;\n  --c-primary-200: 191, 219, 254;\n  --c-primary-300: 147, 197, 253;\n  --c-primary-400: 96, 165, 250;\n  --c-primary-500: 59, 130, 246;\n  --c-primary-600: 37, 99, 235;\n  --c-primary-700: 29, 78, 216;\n  --c-primary-800: 30, 64, 175;\n  --c-primary-900: 30, 58, 138;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 249, 250, 251;\n  --c-neutral-100: 243, 244, 246;\n  --c-neutral-200: 229, 231, 235;\n  --c-neutral-300: 209, 213, 219;\n  --c-neutral-400: 156, 163, 175;\n  --c-neutral-500: 107, 114, 128;\n  --c-neutral-600: 75, 85, 99;\n  --c-neutral-700: 55, 65, 81;\n  --c-neutral-800: 31, 41, 55;\n  --c-neutral-900: 17, 24, 39;\n}\n\n.theme-lightBlue-coolGrey {\n  --c-primary-50: 240, 249, 255;\n  --c-primary-100: 224, 242, 254;\n  --c-primary-200: 186, 230, 253;\n  --c-primary-300: 125, 211, 252;\n  --c-primary-400: 56, 189, 248;\n  --c-primary-500: 14, 165, 233;\n  --c-primary-600: 2, 132, 199;\n  --c-primary-700: 3, 105, 161;\n  --c-primary-800: 7, 89, 133;\n  --c-primary-900: 12, 74, 110;\n  --c-secondary-50: 240, 253, 244;\n  --c-secondary-100: 220, 252, 231;\n  --c-secondary-200: 187, 247, 208;\n  --c-secondary-300: 134, 239, 172;\n  --c-secondary-400: 74, 222, 128;\n  --c-secondary-500: 34, 197, 94;\n  --c-secondary-600: 22, 163, 74;\n  --c-secondary-700: 21, 128, 61;\n  --c-secondary-800: 22, 101, 52;\n  --c-secondary-900: 20, 83, 45;\n  --c-neutral-50: 249, 250, 251;\n  --c-neutral-100: 243, 244, 246;\n  --c-neutral-200: 229, 231, 235;\n  --c-neutral-300: 209, 213, 219;\n  --c-neutral-400: 156, 163, 175;\n  --c-neutral-500: 107, 114, 128;\n  --c-neutral-600: 75, 85, 99;\n  --c-neutral-700: 55, 65, 81;\n  --c-neutral-800: 31, 41, 55;\n  --c-neutral-900: 17, 24, 39;\n}\n\n.theme-pink-coolGrey {\n  --c-primary-50: 253, 242, 248;\n  --c-primary-100: 252, 231, 243;\n  --c-primary-200: 252, 231, 243;\n  --c-primary-300: 249, 168, 212;\n  --c-primary-400: 244, 114, 182;\n  --c-primary-500: 236, 72, 153;\n  --c-primary-600: 219, 39, 119;\n  --c-primary-700: 190, 24, 93;\n  --c-primary-800: 157, 23, 77;\n  --c-primary-900: 131, 24, 67;\n}\n\n.theme-green-grey {\n  --c-primary-50: 240, 253, 244;\n  --c-primary-100: 220, 252, 231;\n  --c-primary-200: 187, 247, 208;\n  --c-primary-300: 134, 239, 172;\n  --c-primary-400: 74, 222, 128;\n  --c-primary-500: 34, 197, 94;\n  --c-primary-600: 22, 163, 74;\n  --c-primary-700: 21, 128, 61;\n  --c-primary-800: 22, 101, 52;\n  --c-primary-900: 20, 83, 45;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 250, 250, 250;\n  --c-neutral-100: 244, 244, 245;\n  --c-neutral-200: 228, 228, 231;\n  --c-neutral-300: 212, 212, 216;\n  --c-neutral-400: 161, 161, 170;\n  --c-neutral-500: 113, 113, 122;\n  --c-neutral-600: 82, 82, 91;\n  --c-neutral-700: 63, 63, 70;\n  --c-neutral-800: 39, 39, 42;\n  --c-neutral-900: 24, 24, 27;\n}\n\n.theme-yellow-grey {\n  --c-primary-50: 254, 252, 232;\n  --c-primary-100: 254, 249, 195;\n  --c-primary-200: 254, 240, 138;\n  --c-primary-300: 253, 224, 71;\n  --c-primary-400: 250, 204, 21;\n  --c-primary-500: 234, 179, 8;\n  --c-primary-600: 202, 138, 4;\n  --c-primary-700: 161, 98, 7;\n  --c-primary-800: 133, 77, 14;\n  --c-primary-900: 133, 77, 14;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 250, 250, 250;\n  --c-neutral-100: 244, 244, 245;\n  --c-neutral-200: 228, 228, 231;\n  --c-neutral-300: 212, 212, 216;\n  --c-neutral-400: 161, 161, 170;\n  --c-neutral-500: 113, 113, 122;\n  --c-neutral-600: 82, 82, 91;\n  --c-neutral-700: 63, 63, 70;\n  --c-neutral-800: 39, 39, 42;\n  --c-neutral-900: 24, 24, 27;\n}\n\n.theme-orange-grey {\n  --c-primary-50: 255, 247, 237;\n  --c-primary-100: 255, 237, 213;\n  --c-primary-200: 254, 215, 170;\n  --c-primary-300: 253, 186, 116;\n  --c-primary-400: 251, 146, 60;\n  --c-primary-500: 249, 115, 22;\n  --c-primary-600: 234, 88, 12;\n  --c-primary-700: 194, 65, 12;\n  --c-primary-800: 154, 52, 18;\n  --c-primary-900: 124, 45, 18;\n  --c-secondary-50: 247, 254, 231;\n  --c-secondary-100: 236, 252, 203;\n  --c-secondary-200: 217, 249, 157;\n  --c-secondary-300: 190, 242, 100;\n  --c-secondary-400: 163, 230, 53;\n  --c-secondary-500: 132, 204, 22;\n  --c-secondary-600: 101, 163, 13;\n  --c-secondary-700: 77, 124, 15;\n  --c-secondary-800: 63, 98, 18;\n  --c-secondary-900: 54, 83, 20;\n  --c-neutral-50: 250, 250, 250;\n  --c-neutral-100: 244, 244, 245;\n  --c-neutral-200: 228, 228, 231;\n  --c-neutral-300: 212, 212, 216;\n  --c-neutral-400: 161, 161, 170;\n  --c-neutral-500: 113, 113, 122;\n  --c-neutral-600: 82, 82, 91;\n  --c-neutral-700: 63, 63, 70;\n  --c-neutral-800: 39, 39, 42;\n  --c-neutral-900: 24, 24, 27;\n}\n\n.theme-fuchsia-blueGrey {\n  --c-primary-50: 253, 244, 255;\n  --c-primary-100: 250, 232, 255;\n  --c-primary-200: 245, 208, 254;\n  --c-primary-300: 240, 171, 252;\n  --c-primary-400: 232, 121, 249;\n  --c-primary-500: 217, 70, 239;\n  --c-primary-600: 192, 38, 211;\n  --c-primary-700: 162, 28, 175;\n  --c-primary-800: 134, 25, 143;\n  --c-primary-900: 112, 26, 117;\n  --c-secondary-50: 240, 253, 250;\n  --c-secondary-100: 204, 251, 241;\n  --c-secondary-200: 153, 246, 228;\n  --c-secondary-300: 153, 246, 228;\n  --c-secondary-400: 45, 212, 191;\n  --c-secondary-500: 20, 184, 166;\n  --c-secondary-600: 13, 148, 136;\n  --c-secondary-700: 15, 118, 110;\n  --c-secondary-800: 17, 94, 89;\n  --c-secondary-900: 19, 78, 74;\n  --c-neutral-50: 248, 250, 252;\n  --c-neutral-100: 241, 245, 249;\n  --c-neutral-200: 226, 232, 240;\n  --c-neutral-300: 203, 213, 225;\n  --c-neutral-400: 148, 163, 184;\n  --c-neutral-500: 100, 116, 139;\n  --c-neutral-600: 71, 85, 105;\n  --c-neutral-700: 51, 65, 85;\n  --c-neutral-800: 30, 41, 59;\n  --c-neutral-900: 15, 23, 42;\n}\n\n@font-face {\n  font-family: Inter;\n  font-weight: 300;\n  src: url(\"../fonts/Inter/static/Inter-Light.ttf\");\n}\n@font-face {\n  font-family: Inter;\n  font-weight: 400;\n  src: url(\"../fonts/Inter/static/Inter-Regular.ttf\");\n}\n@font-face {\n  font-family: Inter;\n  font-weight: 500;\n  src: url(\"../fonts/Inter/static/Inter-Medium.ttf\");\n}\n@font-face {\n  font-family: Inter;\n  font-weight: 600;\n  src: url(\"../fonts/Inter/static/Inter-SemiBold.ttf\");\n}\n@font-face {\n  font-family: Inter;\n  font-weight: 700;\n  src: url(\"../fonts/Inter/static/Inter-Bold.ttf\");\n}\n@font-face {\n  font-family: Poppins;\n  font-weight: 300;\n  src: url(\"../fonts/Poppins/Poppins-Light.ttf\");\n}\n@font-face {\n  font-family: Poppins;\n  font-weight: 400;\n  src: url(\"../fonts/Poppins/Poppins-Regular.ttf\");\n}\n@font-face {\n  font-family: Poppins;\n  font-weight: 500;\n  src: url(\"../fonts/Poppins/Poppins-Medium.ttf\");\n}\n@font-face {\n  font-family: Poppins;\n  font-weight: 600;\n  src: url(\"../fonts/Poppins/Poppins-SemiBold.ttf\");\n}\n@font-face {\n  font-family: Poppins;\n  font-weight: 700;\n  src: url(\"../fonts/Poppins/Poppins-Bold.ttf\");\n}\n@font-face {\n  font-family: MerriweatherSans;\n  font-weight: 300;\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Light.ttf\");\n}\n@font-face {\n  font-family: MerriweatherSans;\n  font-weight: 400;\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Regular.ttf\");\n}\n@font-face {\n  font-family: MerriweatherSans;\n  font-weight: 500;\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Medium.ttf\");\n}\n@font-face {\n  font-family: MerriweatherSans;\n  font-weight: 600;\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-SemiBold.ttf\");\n}\n@font-face {\n  font-family: MerriweatherSans;\n  font-weight: 700;\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Bold.ttf\");\n}\n@font-face {\n  font-family: Kodchasan;\n  font-weight: 300;\n  src: url(\"../fonts/Kodchasan/Kodchasan-Light.ttf\");\n}\n@font-face {\n  font-family: Kodchasan;\n  font-weight: 400;\n  src: url(\"../fonts/Kodchasan/Kodchasan-Regular.ttf\");\n}\n@font-face {\n  font-family: Kodchasan;\n  font-weight: 500;\n  src: url(\"../fonts/Kodchasan/Kodchasan-Medium.ttf\");\n}\n@font-face {\n  font-family: Kodchasan;\n  font-weight: 600;\n  src: url(\"../fonts/Kodchasan/Kodchasan-SemiBold.ttf\");\n}\n@font-face {\n  font-family: Kodchasan;\n  font-weight: 700;\n  src: url(\"../fonts/Kodchasan/Kodchasan-Bold.ttf\");\n}\n@font-face {\n  font-family: BeVietnam;\n  font-weight: 300;\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Light.ttf\");\n}\n@font-face {\n  font-family: BeVietnam;\n  font-weight: 400;\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Regular.ttf\");\n}\n@font-face {\n  font-family: BeVietnam;\n  font-weight: 500;\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Medium.ttf\");\n}\n@font-face {\n  font-family: BeVietnam;\n  font-weight: 600;\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-SemiBold.ttf\");\n}\n@font-face {\n  font-family: BeVietnam;\n  font-weight: 700;\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Bold.ttf\");\n}\nhtml body {\n  @apply font-body antialiased;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  @apply font-display;\n}\n\n:root {\n  --font-display: Poppins;\n  --font-body: Poppins;\n}\n\n.theme-animals {\n  --font-display: Inter;\n  --font-body: Inter;\n}\n\n.theme-astronomy {\n  --font-display: BeVietnam;\n  --font-body: BeVietnam;\n}\n\n.root {\n  overflow: hidden;\n}\n\n#headlessui-portal-root {\n  @apply text-neutral-900 dark:text-neutral-200 text-base;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.hiddenScrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.hiddenScrollbar {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.z-max {\n  z-index: 999999999;\n}\n\n.nc-will-change-transform {\n  will-change: transform;\n}\n\n.nc-will-change-top {\n  will-change: top;\n}\n\n.nc-SectionClientSay .glide__bullet--active {\n  @apply bg-neutral-700;\n}\n\n.nc-GallerySlider .glide__bullet--active {\n  @apply bg-white w-2 h-2;\n}\n\n.nc-card-title {\n  @apply transition-colors hover:text-primary-900 dark:hover:text-primary-300 duration-75;\n}\n\n.nc-PostCardCommentBtn:hover span,\n.nc-PostCardLikeAction:hover span,\n.nc-CommentCardLikeReply > button:hover span {\n  color: inherit;\n}\n\n.nc-box-has-hover {\n  @apply bg-white rounded-3xl border border-neutral-200 border-opacity-70 hover:bg-neutral-50 hover:shadow-xl hover:border-transparent transition-shadow;\n}\n\n.nc-dark-box-bg-has-hover {\n  @apply dark:bg-neutral-800 dark:bg-opacity-30 dark:border dark:border-neutral-700 dark:hover:bg-neutral-800 dark:hover:shadow-2xl;\n}\n\n.nc-dark-box-bg {\n  @apply dark:bg-neutral-800 dark:bg-opacity-30 dark:border dark:border-neutral-700 dark:shadow-2xl;\n}\n\n.nc-origin-100 {\n  transform-origin: 100% 50% 0px;\n}\n\n.nc-origin-50 {\n  transform-origin: 50% 50% 0px;\n}\n\n.nc-hero-field-padding {\n  @apply py-3 px-4 md:py-4 md:px-7 xl:py-6 xl:px-8;\n}\n\n.nc-hero-field-padding--small {\n  @apply py-3 px-4 md:py-3 md:px-7 xl:px-8;\n}\n\n.nc-hero-field-focused {\n  @apply rounded-full dark:bg-white/5;\n  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;\n}\n\n.ListingDetailPage .nc-hero-field-focused {\n  @apply rounded-3xl shadow-2xl;\n}\n.ListingDetailPage.nc-ListingExperiencesDetailPage .ExperiencesDateSingleInput .nc-hero-field-focused {\n  @apply rounded-r-none;\n}\n.ListingDetailPage.nc-ListingExperiencesDetailPage .listingExperiencesDetailPage__GuestsInput .nc-hero-field-focused {\n  @apply rounded-l-none;\n}\n.ListingDetailPage .DateRangePickerInput_clearDates,\n.ListingDetailPage .SingleDatePickerInput_clearDate {\n  @apply rounded-full bg-neutral-200/90 dark:bg-white/10;\n}\n.ListingDetailPage .DateRangePickerInput_clearDates svg,\n.ListingDetailPage .SingleDatePickerInput_clearDate svg {\n  @apply w-2 fill-neutral-700 dark:fill-neutral-300;\n}\n\n.nc-ListingStayDetailPage__guestsInput .nc-hero-field-focused {\n  @apply rounded-t-none;\n}\n\n.nc-ListingStayDetailPage__stayDatesRangeInput .nc-hero-field-focused {\n  @apply rounded-b-none;\n}\n\n.nc-hero-field-focused--2 {\n  @apply rounded-full dark:bg-white/5;\n  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;\n}\n\n.nc-flex-1 {\n  flex: 1 0 0%;\n}\n\n.nc-flex-1\\.5 {\n  flex: 1.5 0 0%;\n}\n\n.nc-flex-1\\.5-auto {\n  flex: 1.5 0 auto;\n}\n\n.nc-flex-2 {\n  flex: 2 0 0%;\n}\n\n.nc-flex-2-auto {\n  flex: 2 0 auto;\n}\n\n.nc-flex-2\\.5 {\n  flex: 2.5 0 0%;\n}\n\n@screen lg {\n  .lg\\:nc-flex-1\\.5 {\n    flex: 1.5 0 0%;\n  }\n  .lg\\:nc-flex-1\\.5-auto {\n    flex: 1.5 0 auto;\n  }\n  .lg\\:nc-flex-2 {\n    flex: 2 0 0%;\n  }\n  .lg\\:nc-flex-2-auto {\n    flex: 2 0 auto;\n  }\n  .lg\\:nc-flex-2\\.5 {\n    flex: 2.5 0 0%;\n  }\n}\n.nc-icon-field {\n  @apply w-5 h-5 lg:w-7 lg:h-7;\n}\n\n.nc-icon-field-2 {\n  @apply w-5 h-5 lg:w-8 lg:h-8;\n}\n\nbutton.gm-control-active.gm-fullscreen-control {\n  @apply rounded-xl !important;\n}\n\n.nc-FiveStartIconForRate svg:hover ~ svg {\n  @apply text-neutral-300;\n}\n\n.listingSection__wrap {\n  @apply w-full flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8;\n}\n\n.listingSectionSidebar__wrap {\n  @apply w-full flex flex-col rounded-2xl border-b border-t border-l border-r border-neutral-200 dark:border-neutral-700 space-y-6 xl:space-y-7 pb-10 p-2 sm:p-4 xl:px-8 xl:py-6;\n}\n\ninput[type=time]::-webkit-calendar-picker-indicator {\n  @apply dark:bg-neutral-500 rounded-md;\n}\n\n[type=button] {\n  -webkit-appearance: none !important;\n}\n\n.rc-slider-track {\n  @apply bg-primary-400;\n}\n\n.rc-slider-handle {\n  @apply border-primary-300;\n}\n\n.nc-PropertyCardH .nc-BtnLikeIcon--liked {\n  @apply text-red-500 dark:text-red-500;\n}\n\n.ncSectionLogos img {\n  @apply w-full;\n  max-width: 200px;\n}\n\n.modalPhotos-single-gallery .glide__bullet--active {\n  @apply block;\n}\n\n.menuIsNew_lv1 > a::before {\n  content: \"New!\";\n  position: absolute;\n  top: -2px;\n  right: 0;\n  display: inline-block;\n  padding: 0 5px;\n  line-height: 15px;\n  border-radius: 4px;\n  background-color: #f35656;\n  color: #fff;\n  font-size: 10px;\n  font-weight: normal;\n}\n\n.menuIsNew > a::after {\n  content: \"New!\";\n  display: inline-block;\n  padding: 0 5px;\n  line-height: 15px;\n  border-radius: 4px;\n  background-color: #f35656;\n  color: #fff;\n  font-size: 10px;\n  margin-left: 6px;\n}\n\n.FooterNav--hide {\n  @apply translate-y-full;\n}\n\n@keyframes myblur {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.nc-custom-shadow-1 {\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;\n}\n\n#desc ul {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.ul-def {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n}\n\n.headx {\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0));\n}\n\n.icoLink {\n  cursor: pointer;\n}\n\niframe {\n  display: none;\n}\n\n.videof {\n  background: rgb(15, 23, 42);\n  background: linear-gradient(90deg, rgb(15, 23, 42) 0%, rgba(9, 9, 121, 0.1755077031) 54%, rgb(15, 23, 42) 100%);\n}\n\n.react-datepicker {\n  @apply relative grid grid-cols-1 gap-10 md:grid-cols-2;\n}\n\n.react-datepicker__aria-live {\n  @apply hidden;\n}\n\n.react-datepicker__month-container {\n  @apply text-center;\n}\n\n.react-datepicker__current-month {\n  @apply text-sm font-semibold text-gray-900 dark:text-gray-100;\n}\n\n.react-datepicker__day-names {\n  @apply mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500 dark:text-gray-400;\n}\n\n.react-datepicker__month {\n  @apply mt-5;\n}\n\n.react-datepicker__week {\n  @apply grid grid-cols-7 my-0.5;\n}\n\n.react-datepicker__day {\n  @apply w-full flex items-center justify-center cursor-pointer empty:opacity-0 empty:cursor-auto empty:hover:bg-transparent text-sm;\n  @apply empty:bg-transparent !important;\n}\n.react-datepicker__day span {\n  @apply rounded-full hover:bg-gray-100 dark:hover:bg-gray-700/60;\n}\n.react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range {\n  @apply bg-gray-100 dark:bg-gray-700/50 rounded-none;\n}\n.react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start {\n  @apply rounded-l-full;\n}\n.react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end {\n  @apply rounded-r-full;\n}\n.react-datepicker__day--selected span, .react-datepicker__day--range-start span, .react-datepicker__day--range-end span, .react-datepicker__day--selecting-range-start span, .react-datepicker__day--selecting-range-end span {\n  @apply bg-primary-500 dark:bg-primary-500 text-white rounded-full hover:bg-primary-500 dark:hover:bg-primary-500;\n}\n.react-datepicker__day--disabled {\n  @apply text-neutral-400 dark:text-neutral-500;\n}\n\n.react-datepicker__day_span {\n  @apply flex h-[46px] w-[46px] items-center justify-center rounded-full;\n}\n\n/* addListingDatePickerExclude */\n.addListingDatePickerExclude .react-datepicker__day--disabled {\n  @apply relative bg-gray-100 dark:bg-gray-700/50 rounded-none empty:opacity-0;\n}\n.addListingDatePickerExclude .react-datepicker__day--disabled::after {\n  content: \"\";\n  @apply block h-full absolute border-l border-neutral-300 dark:border-neutral-700 rotate-45;\n}\n\n.nc-header-bg {\n  @apply bg-white/70 dark:bg-neutral-900/60 backdrop-blur-2xl backdrop-filter;\n}\n\n.glide {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n}\n.glide * {\n  box-sizing: inherit;\n}\n.glide__track {\n  overflow: hidden;\n}\n.glide__slides {\n  position: relative;\n  width: 100%;\n  list-style: none;\n  backface-visibility: hidden;\n  transform-style: preserve-3d;\n  touch-action: pan-Y;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  flex-wrap: nowrap;\n  will-change: transform;\n}\n.glide__slides--dragging {\n  user-select: none;\n}\n.glide__slide {\n  width: 100%;\n  height: 100%;\n  flex-shrink: 0;\n  white-space: normal;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n}\n.glide__slide a {\n  user-select: none;\n  -webkit-user-drag: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n.glide__arrows {\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n.glide__bullets {\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n.glide--rtl {\n  direction: rtl;\n}","// FONT FACE --INTER\r\n@font-face {\r\n  font-family: Inter;\r\n  font-weight: 300;\r\n  src: url(\"../fonts/Inter/static/Inter-Light.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-weight: 400;\r\n  src: url(\"../fonts/Inter/static/Inter-Regular.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-weight: 500;\r\n  src: url(\"../fonts/Inter/static/Inter-Medium.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-weight: 600;\r\n  src: url(\"../fonts/Inter/static/Inter-SemiBold.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-weight: 700;\r\n  src: url(\"../fonts/Inter/static/Inter-Bold.ttf\");\r\n}\r\n\r\n// POPPINS\r\n@font-face {\r\n  font-family: Poppins;\r\n  font-weight: 300;\r\n  src: url(\"../fonts/Poppins/Poppins-Light.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Poppins;\r\n  font-weight: 400;\r\n  src: url(\"../fonts/Poppins/Poppins-Regular.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Poppins;\r\n  font-weight: 500;\r\n  src: url(\"../fonts/Poppins/Poppins-Medium.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Poppins;\r\n  font-weight: 600;\r\n  src: url(\"../fonts/Poppins/Poppins-SemiBold.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Poppins;\r\n  font-weight: 700;\r\n  src: url(\"../fonts/Poppins/Poppins-Bold.ttf\");\r\n}\r\n\r\n//\r\n// FONT FACE --MerriweatherSans\r\n@font-face {\r\n  font-family: MerriweatherSans;\r\n  font-weight: 300;\r\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Light.ttf\");\r\n}\r\n@font-face {\r\n  font-family: MerriweatherSans;\r\n  font-weight: 400;\r\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Regular.ttf\");\r\n}\r\n@font-face {\r\n  font-family: MerriweatherSans;\r\n  font-weight: 500;\r\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Medium.ttf\");\r\n}\r\n@font-face {\r\n  font-family: MerriweatherSans;\r\n  font-weight: 600;\r\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-SemiBold.ttf\");\r\n}\r\n@font-face {\r\n  font-family: MerriweatherSans;\r\n  font-weight: 700;\r\n  src: url(\"../fonts/Merriweather_Sans/static/MerriweatherSans-Bold.ttf\");\r\n}\r\n//\r\n// FONT FACE --Kodchasan\r\n@font-face {\r\n  font-family: Kodchasan;\r\n  font-weight: 300;\r\n  src: url(\"../fonts/Kodchasan/Kodchasan-Light.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Kodchasan;\r\n  font-weight: 400;\r\n  src: url(\"../fonts/Kodchasan/Kodchasan-Regular.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Kodchasan;\r\n  font-weight: 500;\r\n  src: url(\"../fonts/Kodchasan/Kodchasan-Medium.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Kodchasan;\r\n  font-weight: 600;\r\n  src: url(\"../fonts/Kodchasan/Kodchasan-SemiBold.ttf\");\r\n}\r\n@font-face {\r\n  font-family: Kodchasan;\r\n  font-weight: 700;\r\n  src: url(\"../fonts/Kodchasan/Kodchasan-Bold.ttf\");\r\n}\r\n\r\n// FONT FACE --BeVietnam\r\n@font-face {\r\n  font-family: BeVietnam;\r\n  font-weight: 300;\r\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Light.ttf\");\r\n}\r\n@font-face {\r\n  font-family: BeVietnam;\r\n  font-weight: 400;\r\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Regular.ttf\");\r\n}\r\n@font-face {\r\n  font-family: BeVietnam;\r\n  font-weight: 500;\r\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Medium.ttf\");\r\n}\r\n@font-face {\r\n  font-family: BeVietnam;\r\n  font-weight: 600;\r\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-SemiBold.ttf\");\r\n}\r\n@font-face {\r\n  font-family: BeVietnam;\r\n  font-weight: 700;\r\n  src: url(\"../fonts/Be_Vietnam/BeVietnam-Bold.ttf\");\r\n}\r\n\r\n//\r\nhtml body {\r\n  @apply font-body antialiased;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4 {\r\n  @apply font-display;\r\n}\r\n\r\n:root {\r\n  --font-display: Poppins;\r\n  --font-body: Poppins;\r\n}\r\n\r\n.theme-animals {\r\n  --font-display: Inter;\r\n  --font-body: Inter;\r\n}\r\n\r\n.theme-astronomy {\r\n  --font-display: BeVietnam;\r\n  --font-body: BeVietnam;\r\n}\r\n",".root {\r\n  overflow: hidden;\r\n}\r\n\r\n#headlessui-portal-root {\r\n  @apply text-neutral-900 dark:text-neutral-200 text-base;\r\n}\r\n\r\n/* Hide scrollbar for Chrome, Safari and Opera */\r\n.hiddenScrollbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/* Hide scrollbar for IE, Edge and Firefox */\r\n.hiddenScrollbar {\r\n  -ms-overflow-style: none; /* IE and Edge */\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n\r\n.z-max {\r\n  z-index: 999999999;\r\n}\r\n\r\n//\r\n.nc-will-change-transform {\r\n  will-change: transform;\r\n}\r\n.nc-will-change-top {\r\n  will-change: top;\r\n}\r\n//\r\n\r\n.nc-SectionClientSay .glide__bullet--active {\r\n  @apply bg-neutral-700;\r\n}\r\n.nc-GallerySlider .glide__bullet--active {\r\n  @apply bg-white w-2 h-2;\r\n}\r\n\r\n//\r\n.nc-card-title {\r\n  @apply transition-colors  hover:text-primary-900 dark:hover:text-primary-300 duration-75;\r\n}\r\n\r\n//\r\n.nc-PostCardCommentBtn,\r\n.nc-PostCardLikeAction,\r\n.nc-CommentCardLikeReply > button {\r\n  &:hover {\r\n    span {\r\n      color: inherit;\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n.nc-box-has-hover {\r\n  @apply bg-white rounded-3xl border border-neutral-200 border-opacity-70 hover:bg-neutral-50 hover:shadow-xl hover:border-transparent transition-shadow;\r\n}\r\n\r\n.nc-dark-box-bg-has-hover {\r\n  @apply dark:bg-neutral-800 dark:bg-opacity-30  dark:border dark:border-neutral-700 dark:hover:bg-neutral-800 dark:hover:shadow-2xl;\r\n}\r\n\r\n.nc-dark-box-bg {\r\n  @apply dark:bg-neutral-800 dark:bg-opacity-30  dark:border dark:border-neutral-700 dark:shadow-2xl;\r\n}\r\n\r\n//\r\n.nc-origin-100 {\r\n  transform-origin: 100% 50% 0px;\r\n}\r\n.nc-origin-50 {\r\n  transform-origin: 50% 50% 0px;\r\n}\r\n\r\n// HERO\r\n.nc-hero-field-padding {\r\n  @apply py-3 px-4 md:py-4 md:px-7 xl:py-6 xl:px-8;\r\n}\r\n\r\n.nc-hero-field-padding--small {\r\n  @apply py-3 px-4 md:py-3 md:px-7 xl:px-8;\r\n}\r\n\r\n.nc-hero-field-focused {\r\n  @apply rounded-full dark:bg-white/5;\r\n  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px,\r\n    rgba(17, 17, 26, 0.05) 0px 8px 32px;\r\n}\r\n\r\n.ListingDetailPage {\r\n  .nc-hero-field-focused {\r\n    @apply rounded-3xl shadow-2xl;\r\n  }\r\n  &.nc-ListingExperiencesDetailPage {\r\n    .ExperiencesDateSingleInput .nc-hero-field-focused {\r\n      @apply rounded-r-none;\r\n    }\r\n    .listingExperiencesDetailPage__GuestsInput .nc-hero-field-focused {\r\n      @apply rounded-l-none;\r\n    }\r\n  }\r\n\r\n  .DateRangePickerInput_clearDates,\r\n  .SingleDatePickerInput_clearDate {\r\n    @apply rounded-full bg-neutral-200/90 dark:bg-white/10;\r\n    svg {\r\n      @apply w-2 fill-neutral-700 dark:fill-neutral-300;\r\n    }\r\n  }\r\n}\r\n\r\n.nc-ListingStayDetailPage__guestsInput {\r\n  .nc-hero-field-focused {\r\n    @apply rounded-t-none;\r\n  }\r\n}\r\n.nc-ListingStayDetailPage__stayDatesRangeInput {\r\n  .nc-hero-field-focused {\r\n    @apply rounded-b-none;\r\n  }\r\n}\r\n\r\n.nc-hero-field-focused--2 {\r\n  @apply rounded-full dark:bg-white/5;\r\n  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px,\r\n    rgba(17, 17, 26, 0.05) 0px 8px 32px;\r\n}\r\n\r\n.nc-flex-1 {\r\n  flex: 1 0 0%;\r\n}\r\n\r\n.nc-flex-1\\.5 {\r\n  flex: 1.5 0 0%;\r\n}\r\n.nc-flex-1\\.5-auto {\r\n  flex: 1.5 0 auto;\r\n}\r\n\r\n.nc-flex-2 {\r\n  flex: 2 0 0%;\r\n}\r\n\r\n.nc-flex-2-auto {\r\n  flex: 2 0 auto;\r\n}\r\n\r\n.nc-flex-2\\.5 {\r\n  flex: 2.5 0 0%;\r\n}\r\n\r\n@screen lg {\r\n  .lg\\:nc-flex-1\\.5 {\r\n    flex: 1.5 0 0%;\r\n  }\r\n  .lg\\:nc-flex-1\\.5-auto {\r\n    flex: 1.5 0 auto;\r\n  }\r\n\r\n  .lg\\:nc-flex-2 {\r\n    flex: 2 0 0%;\r\n  }\r\n\r\n  .lg\\:nc-flex-2-auto {\r\n    flex: 2 0 auto;\r\n  }\r\n\r\n  .lg\\:nc-flex-2\\.5 {\r\n    flex: 2.5 0 0%;\r\n  }\r\n}\r\n\r\n.nc-icon-field {\r\n  @apply w-5 h-5 lg:w-7 lg:h-7;\r\n}\r\n.nc-icon-field-2 {\r\n  @apply w-5 h-5 lg:w-8 lg:h-8;\r\n}\r\n//\r\nbutton.gm-control-active.gm-fullscreen-control {\r\n  @apply rounded-xl #{!important};\r\n}\r\n\r\n//\r\n.nc-FiveStartIconForRate {\r\n  svg:hover ~ svg {\r\n    @apply text-neutral-300;\r\n  }\r\n}\r\n\r\n// LISTING PAGE DETAIL\r\n.listingSection__wrap {\r\n  @apply w-full flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8;\r\n}\r\n\r\n// LISTING PAGE DETAIL\r\n.listingSectionSidebar__wrap {\r\n  @apply w-full flex flex-col rounded-2xl border-b border-t border-l border-r border-neutral-200 dark:border-neutral-700 space-y-6 xl:space-y-7 pb-10 p-2 sm:p-4 xl:px-8 xl:py-6;\r\n}\r\n\r\n//\r\ninput[type=\"time\"]::-webkit-calendar-picker-indicator {\r\n  @apply dark:bg-neutral-500 rounded-md;\r\n}\r\n\r\n[type=\"button\"] {\r\n  -webkit-appearance: none !important;\r\n}\r\n\r\n//\r\n.rc-slider-track {\r\n  @apply bg-primary-400;\r\n}\r\n.rc-slider-handle {\r\n  @apply border-primary-300;\r\n}\r\n\r\n//\r\n.nc-PropertyCardH {\r\n  .nc-BtnLikeIcon--liked {\r\n    @apply text-red-500 dark:text-red-500;\r\n  }\r\n}\r\n\r\n//\r\n.ncSectionLogos {\r\n  img {\r\n    @apply w-full;\r\n    max-width: 200px;\r\n  }\r\n}\r\n\r\n//\r\n.modalPhotos-single-gallery {\r\n  .glide__bullet--active {\r\n    @apply block;\r\n  }\r\n}\r\n\r\n.menuIsNew_lv1 {\r\n  > a::before {\r\n    content: \"New!\";\r\n    position: absolute;\r\n    top: -2px;\r\n    right: 0;\r\n    display: inline-block;\r\n    padding: 0 5px;\r\n    line-height: 15px;\r\n    border-radius: 4px;\r\n    background-color: #f35656;\r\n    color: #fff;\r\n    font-size: 10px;\r\n    font-weight: normal;\r\n  }\r\n}\r\n.menuIsNew {\r\n  > a::after {\r\n    content: \"New!\";\r\n    display: inline-block;\r\n    padding: 0 5px;\r\n    line-height: 15px;\r\n    border-radius: 4px;\r\n    background-color: #f35656;\r\n    color: #fff;\r\n    font-size: 10px;\r\n    margin-left: 6px;\r\n  }\r\n}\r\n\r\n.FooterNav--hide {\r\n  @apply translate-y-full;\r\n}\r\n\r\n@keyframes myblur {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.nc-custom-shadow-1 {\r\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,\r\n    rgba(17, 17, 26, 0.05) 0px 8px 32px;\r\n}\r\n\r\n#desc ul {\r\n\r\n  list-style-type: disc;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.ul-def{\r\n  list-style-type: disc;\r\n  padding-left: 1.25rem;\r\n}\r\n\r\n.headx\r\n{\r\n  background-image: linear-gradient(to right, rgba(255,255,255,0),rgba(255,255,255,0.4), rgba(255,255,255,0.3),rgba(255,255,255,0),rgba(255,255,255,0));\r\n\r\n}\r\n\r\n.icoLink\r\n{\r\n  cursor: pointer;\r\n}\r\n\r\niframe\r\n{\r\n    display: none;\r\n}\r\n\r\n.videov\r\n{\r\n  \r\n}\r\n\r\n.videof\r\n{\r\n  background: rgb(15,23,42);\r\n  background: linear-gradient(90deg, rgba(15,23,42,1) 0%, rgba(9,9,121,0.17550770308123254) 54%, rgba(15,23,42,1) 100%);\r\n}",".react-datepicker {\r\n  @apply relative grid grid-cols-1 gap-10 md:grid-cols-2;\r\n}\r\n.react-datepicker__aria-live {\r\n  @apply hidden;\r\n}\r\n\r\n.react-datepicker__month-container {\r\n  @apply text-center;\r\n}\r\n\r\n.react-datepicker__current-month {\r\n  @apply text-sm font-semibold text-gray-900 dark:text-gray-100;\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  @apply mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500 dark:text-gray-400;\r\n}\r\n\r\n.react-datepicker__month {\r\n  @apply mt-5;\r\n}\r\n\r\n.react-datepicker__week {\r\n  @apply grid grid-cols-7 my-0.5;\r\n}\r\n\r\n.react-datepicker__day {\r\n  @apply w-full flex items-center justify-center cursor-pointer empty:opacity-0 empty:cursor-auto empty:hover:bg-transparent text-sm;\r\n  @apply empty:bg-transparent #{!important};\r\n\r\n  span {\r\n    @apply rounded-full hover:bg-gray-100 dark:hover:bg-gray-700/60;\r\n  }\r\n\r\n  &--in-range,\r\n  &--in-selecting-range {\r\n    @apply bg-gray-100 dark:bg-gray-700/50 rounded-none;\r\n  }\r\n\r\n  &--range-start,\r\n  &--selecting-range-start {\r\n    @apply rounded-l-full;\r\n  }\r\n  &--range-end,\r\n  &--selecting-range-end {\r\n    @apply rounded-r-full;\r\n  }\r\n\r\n  &--selected,\r\n  &--range-start,\r\n  &--range-end,\r\n  &--selecting-range-start,\r\n  &--selecting-range-end {\r\n    span {\r\n      @apply bg-primary-500 dark:bg-primary-500 text-white rounded-full hover:bg-primary-500 dark:hover:bg-primary-500;\r\n    }\r\n  }\r\n\r\n  &--disabled {\r\n    @apply text-neutral-400 dark:text-neutral-500;\r\n  }\r\n}\r\n\r\n.react-datepicker__day_span {\r\n  @apply flex h-[46px] w-[46px] items-center justify-center rounded-full;\r\n}\r\n\r\n/* addListingDatePickerExclude */\r\n.addListingDatePickerExclude {\r\n  .react-datepicker__day {\r\n    &--disabled {\r\n      @apply relative bg-gray-100 dark:bg-gray-700/50 rounded-none empty:opacity-0;\r\n      &::after {\r\n        content: \"\";\r\n        @apply block h-full absolute border-l border-neutral-300 dark:border-neutral-700 rotate-45;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".nc-header-bg {\r\n  @apply bg-white/70 dark:bg-neutral-900/60 backdrop-blur-2xl backdrop-filter;\r\n}\r\n","@import \"variables\";\r\n\r\n.#{$glide-class} {\r\n  $this: &;\r\n\r\n  $se: $glide-element-separator;\r\n  $sm: $glide-modifier-separator;\r\n\r\n  position: relative;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n\r\n  * {\r\n    box-sizing: inherit;\r\n  }\r\n\r\n  &#{$se}track {\r\n    overflow: hidden;\r\n  }\r\n\r\n  &#{$se}slides {\r\n    position: relative;\r\n    width: 100%;\r\n    list-style: none;\r\n    backface-visibility: hidden;\r\n    transform-style: preserve-3d;\r\n    touch-action: pan-Y;\r\n    overflow: hidden;\r\n    margin: 0;\r\n    padding: 0;\r\n    white-space: nowrap;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    will-change: transform;\r\n\r\n    &#{$glide-modifier-separator}dragging {\r\n      user-select: none;\r\n    }\r\n  }\r\n\r\n  &#{$se}slide {\r\n    width: 100%;\r\n    height: 100%;\r\n    flex-shrink: 0;\r\n    white-space: normal;\r\n    user-select: none;\r\n    -webkit-touch-callout: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n\r\n    a {\r\n      user-select: none;\r\n      -webkit-user-drag: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n    }\r\n  }\r\n\r\n  &#{$se}arrows {\r\n    -webkit-touch-callout: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &#{$se}bullets {\r\n    -webkit-touch-callout: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &#{$sm}rtl {\r\n    direction: rtl;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
